import { Component, OnInit, Input, HostListener } from '@angular/core';
import { IToast } from '../visual/visual.reducer';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { hideToast } from '../visual/visual.actions';

const HIDE_TOAST_TIMEOUT = 2000;

@Component({
  selector: 'nns-toast',
  template: `
  <div class="nns-toast-content" flex layout="row" layout-align="start stretch">
    <div class="nns-toast-text" flex layout="row" layout-align="start center">{{toast.text}}</div>
  </div>
  `,
  styles: [`
    :host {
      overflow:hidden;
      min-width:250px;
      max-width:500px;
      display:block;
      margin:8px;
    }
    .nns-toast-content {
      padding:8px;
      background: #fff;
      border: 1px solid rgba(0,0,0,0.12);
      border-radius: 4px;
      color: #161616;
      box-shadow: 0 9px 14px 0 rgba(0, 0, 0, 0.17);
      font-weight: bold;
    }
    .nns-toast-text {
      padding:8px;
      justify-content: center;
    }
    .nns-toast-action {
      padding:0 0 0 8px;
      border-left:1px solid rgba(255,255,255,0.12);
    }
  `, `
    :host-context(.nns-theme-night) .nns-toast-content {
      background: #292E32;
      border:1px solid rgba(255, 255, 255, 0.16);
      color: rgba(255, 255, 255, 0.87);
    }
  `]
})
export class ToastComponent implements OnInit {
  @Input() toast: IToast;
  toastClickEvent = null;
  clickCount = 0;

  constructor(
    public _store: Store<IAppState>
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.close();
    }, HIDE_TOAST_TIMEOUT);
  }

  @HostListener('click', ['$event'])
  onClick(event) {
    this.toastClickEvent = event;
    this.close();
  }

  @HostListener('document: click', ['$event'])
  onDocumentClick(event) {
    if (event !== this.toastClickEvent && this.clickCount) {
      this.close();
    }
    this.toastClickEvent = null;
    this.clickCount = this.clickCount++;
  }

  close() {
    this._store.dispatch(hideToast(this.toast));
  }
}
